export class SearchSynonymApi {
  #http;

  constructor(http) {
    this.#http = http;
  }

  // Company scope is resolved server-side from the auth context; the {companyId} route segment is
  // shape-only, so callers pass the master company id purely to satisfy the URL template.
  async getSearchSynonymGroups({ companyId, includeDeleted = false }) {
    return this.#http.get(`/api/companies/${companyId}/search-synonyms`, {
      params: { includeDeleted },
    });
  }

  async createSearchSynonymGroup({ companyId, ...body }) {
    return this.#http.post(`/api/companies/${companyId}/search-synonyms`, body);
  }

  async updateSearchSynonymGroup({ companyId, synonymGroupId, ...body }) {
    return this.#http.put(`/api/companies/${companyId}/search-synonyms/${synonymGroupId}`, body);
  }

  async deleteSearchSynonymGroup({ companyId, synonymGroupId }) {
    return this.#http.delete(`/api/companies/${companyId}/search-synonyms/${synonymGroupId}`);
  }
}
